import { render, staticRenderFns } from "./ConventionPushSection.vue?vue&type=template&id=19d38368&scoped=true"
import script from "./ConventionPushSection.vue?vue&type=script&lang=js"
export * from "./ConventionPushSection.vue?vue&type=script&lang=js"
import style0 from "./ConventionPushSection.vue?vue&type=style&index=0&id=19d38368&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d38368",
  null
  
)

export default component.exports